<template>
  <ul id="mytab">
    <li
      v-for="(item, index) in tab"
      :key="index"
      :class="{ active: index == now }"
      @click="change(item, index)"
      :style="{ width }"
    >
      {{ item.title }}
    </li>
  </ul>
</template>
<script>
export default {
  props: ["tab", "active"],
  data() {
    return {
      now: 0,
      width: "33.33%",
    };
  },
  methods: {
    change(v, index) {
      this.now = index;
      this.$emit("tab", v);
    },
  },
  mounted() {
    this.now = this.active;
    this.width = 100 / this.tab.length + "%";
  },
};
</script>
<style lang="">
#mytab {
  display: flex;
  background: #fff;
  line-height: 36px;
  margin-bottom: 10px;
}
#mytab li {
  text-align: center;
}
#mytab li.active {
  border-bottom: solid 2px #2e6bf0;
}
</style>


// WEBPACK FOOTER //
// src/components/common/myTab.vue